import { render, staticRenderFns } from "./DetailRecommendSidebar.vue?vue&type=template&id=106d0aee&scoped=true"
import script from "./DetailRecommendSidebar.vue?vue&type=script&lang=js"
export * from "./DetailRecommendSidebar.vue?vue&type=script&lang=js"
import style0 from "./DetailRecommendSidebar.vue?vue&type=style&index=0&id=106d0aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106d0aee",
  null
  
)

export default component.exports